import { gql, useQuery } from '@apollo/client'
import { CircularProgress, Stack } from '@mui/material'

import TimelineTable from './TimelineTable'
import { TIMELINE_FRAGMENT } from './constants'
import TimelinesContext from './context'

const FIND_TIMELINES = gql`
  ${TIMELINE_FRAGMENT}
  query FIND_TIMELINES($filter: JSON!) {
    timelines: findTimelines(filter: $filter) {
      ...TimelineFragment
    }
  }
`

function Timelines() {
  const { loading, error, data } = useQuery(FIND_TIMELINES, {
    variables: { filter: {} },
  })

  if (loading)
    return (
      <Stack
        sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}
      >
        <CircularProgress />
      </Stack>
    )
  if (error) return <p>error...</p>

  const { timelines } = data

  return (
    <TimelinesContext.Provider value={{ timelines }}>
      <TimelineTable />
    </TimelinesContext.Provider>
  )
}

export default Timelines
